import { createRoute } from '@tanstack/react-router';

import { parseWidgetFilter } from '$/pages/SpectrumWidgetPage/widgetFilter';
import { RootRoute } from '$/routes/RootRoute';

const toOptionalText = (value: unknown) =>
  typeof value === 'string' ? value.trim() || undefined : undefined;

export const SpectrumWidgetRoute = createRoute({
  getParentRoute: () => RootRoute,
  path: '/spectrum-widget',
  validateSearch: (search) => ({
    ...parseWidgetFilter(search),
    pimId: toOptionalText(search.pimId),
    producer: toOptionalText(search.producer),
  }),
}).lazy(() =>
  import('$/pages/SpectrumWidgetPage/route').then(
    (d) => d.LazySpectrumWidgetRoute,
  ),
);
